<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">Activity Logs</h1>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Staffs -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Staffs</h4>

            <p>The table below shows the activity logs for staffs.</p>

            <div class="input-group mb-4 d-flex flex-row-reverse p2">
              <button
                type="button"
                @click="staffSearchFor"
                class="btn btn-primary"
              >
                <i class="fas fa-search"></i>
              </button>
              <div class="form-outline">
                <input
                  type="input"
                  v-model="staffSearchItem"
                  class="form-control"
                />
              </div>
            </div>

            <div class="table-responsive">
              <table
                id="log_staffs_tbl"
                class="display table table-striped table-bordered"
                style="width: 100%"
              >
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Role</th>
                    <th>Activity</th>
                    <th>Timestamp</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(log, index) in staffs_log" v-bind:key="index">
                    <td>{{ log.name }}</td>
                    <td style="text-align: left">
                      <span
                        v-for="(role, index) in log.roles"
                        v-bind:key="index"
                        >- {{ role.name }}<br
                      /></span>
                    </td>
                    <td>{{ log.activity }}</td>
                    <td>
                      {{ log.created_at }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <pagination
                v-model="staffPageInfo.current_page"
                :per-page="staffPageInfo.per_page"
                :records="staffPageInfo.total"
                @paginate="handleStaffPageChange"
              />
            </div>
          </div>
        </div>

        <br />
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>

        <br />

        <!-- Customers -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Customers</h4>

            <p>The table below shows the activity logs for customers.</p>

            <div class="input-group mb-4 d-flex flex-row-reverse p2">
              <button
                type="button"
                @click="customerSearchFor"
                class="btn btn-primary"
              >
                <i class="fas fa-search"></i>
              </button>
              <div class="form-outline">
                <input
                  type="input"
                  v-model="customerSearchItem"
                  class="form-control"
                />
              </div>
            </div>

            <div class="table-responsive">
              <table
                id="log_customers_tbl"
                class="display table table-striped table-bordered"
                style="width: 100%"
              >
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Activity</th>
                    <th>Timestamp</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(log, index) in customers_log" v-bind:key="index">
                    <td>{{ log.name }}</td>
                    <td>{{ log.activity }}</td>
                    <td>
                      {{ log.created_at }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <pagination
                v-model="customerPageInfo.current_page"
                :per-page="customerPageInfo.per_page"
                :records="customerPageInfo.total"
                @paginate="handleCustomerPageChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Pagination from "vue-pagination-2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "log",
  components: {
    Pagination,
    Loading,
  },

  data() {
    return {
      staffs_log: [],
      customers_log: [],

      staffPageInfo: {
        current_page: 1,
        next_page_url: null,
        previous_page_url: null,
        total: 0,
        count: 0,
        per_page: 0,
        last_page: 0,
      },

      customerPageInfo: {
        current_page: 1,
        next_page_url: null,
        previous_page_url: null,
        total: 0,
        count: 0,
        per_page: 0,
        last_page: 0,
      },

      isLoading: false,
      fullPage: true,
      staffSearchItem: null,
      customerSearchItem: null,
    };
  },

  methods: {
    async loadStaffsLog() {
      // check if has token
      if (!this.checkToken()) {
        return;
      }

      try {
        let result = await axios.get("/log/staffs", {
          headers: {
            Authorization: "Bearer " + this.checkToken(),
          },
        });

        if (!result.data.user_logs) {
          swal({
            text: result.data.message,
            icon: "error",
            button: "OK",
          }).then(() => {
            this.$router.push("/login");
            localStorage.clear();
          });
        }

        this.staffs_log = result.data.user_logs;
        this.staffPageInfo = result.data.pagination;
      } catch (e) {
        console.log(e);
      }
    },

    async handleStaffPageChange(page) {
      this.isLoading = true;

      let api_url = "";
      if (this.searchItem == null || this.searchItem == "") {
        api_url = `/log/staffs?page=${page}`;
      } else {
        api_url = `/log/staffs?search=${this.searchItem}&page=${page}`;
      }

      let result = await axios.get(api_url, {
        headers: {
          Authorization: "Bearer " + this.checkToken(),
        },
      });

      this.staffs_log = result.data.user_logs;
      this.staffPageInfo = result.data.pagination;
      this.isLoading = false;
    },

    async staffSearchFor() {
      this.isLoading = true;

      let api_url = `/log/staffs?search=${this.staffSearchItem}`;
      if (this.staffSearchItem == null || this.staffSearchItem == "") {
        api_url = `/log/staffs`;
      }

      if (!this.checkToken()) {
        console.log("Unauthorised");
        this.isLoading = false;
        return;
      }
      try {
        let result = await axios.get(api_url, {
          headers: {
            Authorization: "Bearer " + this.checkToken(),
          },
        });

        this.staffs_log = result.data.user_logs;
        this.staffPageInfo = result.data.pagination;
        this.isLoading = false;
      } catch (e) {
        console.log(e);
      }
    },

    async loadCustomersLog() {
      // check if has token
      if (!this.checkToken()) {
        return;
      }

      try {
        let result = await axios.get("/log/customers", {
          headers: {
            Authorization: "Bearer " + this.checkToken(),
          },
        });

        this.customers_log = result.data.user_logs;
        this.customerPageInfo = result.data.pagination;
      } catch (e) {
        console.log(e);
      }
    },

    async handleCustomerPageChange(page) {
      this.isLoading = true;

      let api_url = "";
      if (this.searchItem == null || this.searchItem == "") {
        api_url = `/log/customers?page=${page}`;
      } else {
        api_url = `/log/customers?search=${this.searchItem}&page=${page}`;
      }

      let result = await axios.get(api_url, {
        headers: {
          Authorization: "Bearer " + this.checkToken(),
        },
      });

      this.customers_log = result.data.user_logs;
      this.customerPageInfo = result.data.pagination;
      this.isLoading = false;
    },

    async customerSearchFor() {
      this.isLoading = true;

      let api_url = `/log/customers?search=${this.customerSearchItem}`;
      if (this.customerSearchItem == null || this.customerSearchItem == "") {
        api_url = `/log/customers`;
      }

      if (!this.checkToken()) {
        console.log("Unauthorised");
        this.isLoading = false;
        return;
      }
      try {
        let result = await axios.get(api_url, {
          headers: {
            Authorization: "Bearer " + this.checkToken(),
          },
        });

        this.customers_log = result.data.user_logs;
        this.customerPageInfo = result.data.pagination;
        this.isLoading = false;
      } catch (e) {
        console.log(e);
      }
    },

    checkToken() {
      let token = localStorage.getItem("token");

      if (token === null || token === "") {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;

      return token;
    },
  },

  async created() {
    this.isLoading = true;
    await this.loadStaffsLog();
    await this.loadCustomersLog();
    this.isLoading = false;
  },
};
</script>
